export default __webpack_public_path__ + "static/media/lion@2x.dd27d715.png";